/**
 * Sanitize user input into a valid Jitsi room name.
 * Jitsi allows letters, numbers, and some special chars.
 */
export function sanitizeRoomName(name) {
  if (!name || typeof name !== "string") return "";
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-_]/g, "")
    .slice(0, 64);
}

export function generateRoomName() {
  const slug = Math.random().toString(36).substring(2, 8);
  return `biz-${slug}`;
}

export function getRoomFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const meetingId = params.get("meetingId") || params.get("room");
  return meetingId ? sanitizeRoomName(meetingId) : "";
}

export function setRoomInUrl(roomName) {
  const url = new URL(window.location.href);
  url.searchParams.set("meetingId", roomName);
  window.history.replaceState({}, "", url.toString());
}

export function isValidRoomName(name) {
  const sanitized = sanitizeRoomName(name);
  return sanitized.length >= 3;
}

export function buildMeetingShareUrl(roomName) {
  const url = new URL(window.location.origin + window.location.pathname);
  url.searchParams.set("meetingId", roomName);
  return url.toString();
}
